export default __webpack_public_path__ + "static/media/ellipsis.b70a4233.svg";